// extracted by mini-css-extract-plugin
export default {"buttons":"filters_config_form-module___buttons___ea158322"};